import FormInputs from "../services/inputs-service.js";
const template = `
    <transition name="fade">
        <div class="loading-screen" v-if="isLoading" aria-busy="true">
            <div class="loading-screen-spinner"></div>
            <h1 role="status" aria-live="polite" aria-atomic="true" class="loading-screen-text">{{loadingText}}</h1>
        </div>
    </transition>
`;

export default {
    name: 'b-loading',
    template,
    props: ['iuid'],
    computed: {
        ...Vuex.mapGetters([
            'loading',
            'funnel'
        ]),
        input: function () {
            return this.funnel.elements[this.iuid];
        },
        isLoading: function(){
            return this.loading.status
        },
        loadingText: function(){
            return this.loading.text
        }
    },
    methods: {
        exec: function (e, fxn) {
            const fi = new FormInputs({ ctx: this.$store, router: this.$router });
            const input = this.input;
            eval(`fi.${fxn}(e, input)`);
        }
    }
};